import React, { useState } from 'react';
import { Menu, Search, RefreshCw, X, Sparkles } from 'lucide-react';
import UserMenu from './UserMenu';
import { useT } from '../lib/LanguageContext';

export default function TopBar({ onSearch, onRefresh, busy, onToggleSidebar, searching }) {
  const t = useT();
  const [q, setQ] = useState('');
  const [focused, setFocused] = useState(false);

  const onChange = (e) => {
    const v = e.target.value;
    setQ(v);
    onSearch(v);
  };

  const submit = (e) => {
    e?.preventDefault?.();
    if (!q.trim()) return;
    onSearch(q.trim());
  };

  return (
    <header className="sticky top-0 z-30 bg-keep-topbar border-b border-keep-topbarBorder">
      <div className="h-14 md:h-16 px-1.5 md:px-4 flex items-center gap-1 md:gap-4">
        <button
          onClick={onToggleSidebar}
          className="p-2 md:p-3 rounded-full hover:bg-keep-hover transition-colors flex-shrink-0"
          aria-label={t('topBar.menu')}
          data-testid="topbar-menu-button"
        >
          <Menu className="w-5 h-5 text-keep-textMuted" />
        </button>

        <div className="flex items-center gap-2 flex-shrink-0">
          <img
            src="/logo192.png"
            alt="Recycle Brain"
            className="w-8 h-8 md:w-9 md:h-9 rounded-lg"
            data-testid="brand-logo"
          />
          <div>
            <div className="text-[17px] md:text-[20px] leading-tight text-keep-textMuted font-medium" data-testid="brand-name">
              Recycle Brain
            </div>
          </div>
        </div>

        <div className="relative hidden md:block flex-1 min-w-0 max-w-[480px]">
          {searching && (
            <div className="absolute inset-0 rounded-full search-glow-ring pointer-events-none" aria-hidden />
          )}
          <form
            onSubmit={submit}
            className={`relative m-[2px] flex items-center gap-1.5 md:gap-2 rounded-full px-2 md:px-4 h-10 md:h-12 transition-colors ${
              focused
                ? 'bg-keep-searchBgFocus shadow-keep'
                : 'bg-keep-searchBg hover:bg-keep-searchBgFocus hover:shadow-keep'
            }`}
          >
            <button
              type="submit"
              className="p-1 -ml-1 rounded-full hover:bg-keep-hover flex-shrink-0"
              aria-label={t('topBar.search')}
              data-testid="topbar-search-button"
            >
              <Search className="w-5 h-5 text-keep-textMuted" />
            </button>
            <input
              value={q}
              onChange={onChange}
              onFocus={() => setFocused(true)}
              onBlur={() => setFocused(false)}
              placeholder={t('topBar.searchPlaceholder')}
              className="flex-1 min-w-0 bg-transparent outline-none text-[14px] md:text-[15px] text-keep-text placeholder:text-keep-textMuted"
              data-testid="topbar-search-input"
            />
            {q ? (
              <button
                type="button"
                onClick={() => {
                  setQ('');
                  onSearch('');
                }}
                className="p-1 rounded-full hover:bg-keep-hover flex-shrink-0"
                aria-label={t('topBar.clear')}
                data-testid="topbar-search-clear"
              >
                <X className="w-4 h-4 text-keep-textMuted" />
              </button>
            ) : (
              <Sparkles className="w-4 h-4 text-keep-accent flex-shrink-0" aria-hidden />
            )}
          </form>
        </div>

        <div className="flex items-center gap-0.5 md:gap-1 flex-shrink-0 ml-auto">
          <button
            onClick={onRefresh}
            className={`hidden md:block p-3 rounded-full hover:bg-keep-hover transition-colors ${busy ? 'animate-spin' : ''}`}
            aria-label={t('topBar.refresh')}
            data-testid="topbar-refresh"
          >
            <RefreshCw className="w-5 h-5 text-keep-textMuted" />
          </button>
          <UserMenu />
        </div>
      </div>
    </header>
  );
}
